import { CREATE_DOWNLOADABLE, CREATING_DOWNLOADABLE, DELETE_DOWNLOADABLE, DELETING_DOWNLOADABLE, DOWNLOADABLES_ERROR, GET_DOWNLOADABLES, GETTING_DOWNLOADABLES, UPDATE_DOWNLOADABLE, UPDATING_DOWNLOADABLE } from "../types"


const initialState = {
    downloadables: [],
    loadingDownloadables: true,
    downloadablesError: null,
    creatingDownloadable: false,
    createdDownloadable: null,
    updatingDownloadable: false,
    updatedDownloadable: null,
    deletingDownloadable: false,
    deletedDownloadable: null
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){

    switch(action.type){
        case GETTING_DOWNLOADABLES:
        return {
            ...state,
            loadingDownloadables: action.payload,
        }
        case GET_DOWNLOADABLES:
        return{
            ...state,
            loadingDownloadables:false,
            downloadablesError:  null,
            downloadables: action.payload,
        }
        case CREATING_DOWNLOADABLE:
        return {
            ...state,
            creatingDownloadable: action.payload,
        }
        case CREATE_DOWNLOADABLE:
        return{
            ...state,
            creatingDownloadable:false,
            downloadablesError: null,
            createdDownloadable: action.payload,
        }
        case UPDATING_DOWNLOADABLE:
        return {
            ...state,
            updatingDownloadable: action.payload,
        }
        case UPDATE_DOWNLOADABLE:
        return{
            ...state,
            updatingDownloadable:false,
            downloadablesError: null,
            updatedDownloadable: action.payload,
        }
        case DELETING_DOWNLOADABLE:
        return {
            ...state,
            deletingDownloadable: action.payload,
        }
        case DELETE_DOWNLOADABLE:
        return{
            ...state,
            deletingDownloadable:false,
            downloadablesError: null,
            deletedDownloadable: action.payload,
        }
        case DOWNLOADABLES_ERROR:
        return{
            ...state,
            loadingDownloadable:false,
            creatingDownloadable:false,
            updatingDownloadable: false,
            deletingDownloadable: false,
            downloadablesError: action.payload 
        }
        default: return state
    }

}